document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;
  const isEn = path.includes("/en-global");
  const isZh = path.includes("/zh-traditional");
  const langPrefix = isEn ? "/en-global" : isZh ? "/zh-traditional" : "";

  // 1. 言語ディレクトリの維持
  if (langPrefix !== "") {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");

      if (
        !href ||
        href.startsWith("#") ||
        href.startsWith("javascript:") ||
        href.startsWith(langPrefix)
      ) {
        return;
      }

      if (href.startsWith("/") && !href.startsWith("/apps/")) {
        link.setAttribute("href", langPrefix + href);
      }

      if (
        href.startsWith("https://syrinx.audio/") &&
        !href.startsWith("https://syrinx.audio" + langPrefix + "/")
      ) {
        link.setAttribute(
          "href",
          href.replace(
            "https://syrinx.audio/",
            "https://syrinx.audio" + langPrefix + "/"
          )
        );
      }
    });
  }

  // 2. 救済リダイレクト
  if (path.startsWith("/en/")) {
    window.location.replace(
      path.replace("/en/", "/en-global/") + window.location.search
    );
  }

  if (path.startsWith("/en-global/ja/")) {
    window.location.replace(
      path.replace("/en-global/ja/", "/") + window.location.search
    );
  }
});